var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "progress",
    {
      class: ["dc-progress"],
      attrs: { max: _vm.max },
      domProps: { value: _vm.value },
    },
    [_vm._v(" " + _vm._s(_vm.value) + "% ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }